import ScatterChartComponent from './ScatterChartComponent';
import './ScatterChartComponent.scss';

export default ScatterChartComponent;